import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { Div, P } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import { StyledInput } from '../../../legacy-checkout/checkout-styled-components';

const textDefaults = css`
  ${TYPOGRAPHY.CIRCULAR.book}
  font-size: 15px;
  color: ${BRAND_COLORS.black};
  text-align: left;
`;

const directionMap = {
  up: 'bottom',
  down: 'top',
};

// convert up/down to bottom/top CSS properties (e.g. `bottom: 100%;`)
const getCssPositionProperty = dropDirection =>
  directionMap[dropDirection] || directionMap.down;

const getOpenDropdownStyles = (dropDirection, maxHeight) =>
  css`
    min-height: 50px;
    max-height: ${maxHeight}px;
    ${getCssPositionProperty(dropDirection)}: 100%;
    border-color: ${colors.gray6};
    border-radius: 10px;
    opacity: 1;
  `;

const getClosedDropdownStyles = dropDirection => css`
  min-height: 0;
  max-height: 0;
  ${getCssPositionProperty(dropDirection)}: 80%;
  border-color: ${colors.white};
  border-radius: 0;
  opacity: 0;

  /* Fade-in effect */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(
      180deg,
      ${colors.transparent},
      ${colors.white} 80%
    );
  }
`;

const handleOpenState = ({ $shouldShow, $dropDirection, $maxHeight }) =>
  $shouldShow
    ? getOpenDropdownStyles($dropDirection, $maxHeight)
    : getClosedDropdownStyles($dropDirection);

export const DropdownParent = styled(Div)`
  position: absolute;
  z-index: 999;

  display: flex;
  flex-direction: column;
  justify-content: ${({ $center }) => ($center ? 'center' : 'flex-start')};

  background: ${colors.white};
  border-width: 1px;
  border-style: solid;

  width: 100%;
  overflow: hidden;

  /* Transition animation for open/close */
  transition: all 0.15s ease-in-out, border-color 0.05s ease-out;
  ${props => handleOpenState(props)}
`;

export const FloatingStyledDiv = styled(Div)`
  display: flex;
  flex-direction: column;

  padding: 12px;

  background: ${colors.white};
  border: none;

  width: 100%;

  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: ${colors.gray6} ${colors.gray14};
`;

export const NoResultsP = styled(P)`
  ${textDefaults}
`;

const getLabelStyles = ({ isLabel }) => {
  if (!isLabel) {
    return;
  }

  return css`
    padding-left: 4px;
    color: ${BRAND_COLORS.darkStroke};
    cursor: default;
    pointer-events: none;
  `;
};

export const OptionButton = styled.button`
  ${textDefaults}

  width: 100%;
  background: none;
  border: none;
  outline: none;

  padding: 12px;
  border-radius: 4px;

  ${getLabelStyles}

  ${({ $isHovered }) => $isHovered && css`  background: ${BRAND_COLORS.ashGreen};`}
`;

export const FloatingStyledInput = styled(StyledInput)`
  && {
    padding: 24px 12px 10px;
    z-index: unset !important;
    gap: 4px;
  }

  > .ant-input {
    font-size: 16px;
    font-weight: 600;
    color: ${BRAND_COLORS.black};
    height: auto;
    padding: 24px 12px 10px;

    :focus-visible {
      outline: none !important;
    }
  }

  > .ant-input-suffix {
    margin: 0;
  }
`;
